module.exports = [
    '\\(privoxy/',
    '^ng/',
    '008/',
    '192\\.comAgent',
    '8484 Boston Project',
    'Abonti',
    'Aboundex',
    'aboutthedomain',
    'accoona',
    'ackerm\\.com',
    'acoon',
    'Ad Muncher',
    'adbeat',
    'AddThis',
    'ADmantX',
    'agada.de',
    'agadine/',
    'aggregator',
    'aiderss/',
    'airmail',
    'aladin/',
    'alertra\\.com',
    'alexa site audit',
    'allrati/',
    'AltaVista Intranet',
    'AlwaysOnline',
    'alyze\\.info',
    'amzn_assoc',
    'analyza',
    'analyzer',
    'Anemone',
    'anonymouse\\.org/',
    'answerbus\\.com',
    'Anturis Agent',
    'Aport',
    'AppEngine-Google',
    'appie',
    'Arachmo',
    'arachnode\\.net',
    'Arachnoidea',
    'Arachnophilia/',
    'araneo/',
    'archive',
    'archiving',
    'arianna\\.it',
    'asafaweb\\.com',
    'asahina-antenna/',
    'ask[-\\s]?jeeves',
    'ask\\.24x\\.info',
    'aspseek/',
    'AspTear',
    'assort/',
    'asterias/',
    'atomic_email_hunter',
    'atomz/',
    'augurfind',
    'augurnfind',
    'Avirt Gateway Server',
    'Azureus',
    'B_l_i_t_z_B_O_T',
    'B-l-i-t-z-B-O-T',
    'ba\\.be',
    'BackStreet Browser',
    'BCKLINKS 1\\.0',
    'beammachine/',
    'beebwaredirectory',
    'bibnum\\.bnf',
    'Big Brother',
    'Big Fish',
    'BigBozz/',
    'bigbrother/',
    'biglotron',
    'bilbo/',
    'BilderSauger',
    'BingPreview',
    'binlar',
    'BlackWidow',
    'blaiz-bee/',
    'bloglines/',
    'Blogpulse',
    'blogzice/',
    'BMLAUNCHER',
    'bobby/',
    'boitho\\.com-dc',
    'bookdog/x\\.x',
    'Bookmark Buddy',
    'Bookmark Renewal',
    'bookmarkbase',
    'BorderManager',
    'bot',
    'BravoBrian',
    'Browsershots',
    'bsdseek/',
    'btwebclient/',
    'BUbiNG',
    'BullsEye',
    'BunnySlippers',
    'Buscaplus',
    'Butterfly/',
    'BW-C-2',
    'bwh3_user_agent',
    'calif/',
    'capture',
    'carleson',
    'CC Metadata Scaper',
    'ccubee/x\\.x',
    'CE-Preload',
    'Cerberian Drtrs',
    'CERN-HTTPD',
    'cg-eye interactive',
    'changedetection',
    'Charlotte',
    'charon/',
    'Chat Catcher/',
    'check',
    'China Local Browse',
    'Chitika ContentHit',
    'CJB\\.NET Proxy',
    'classify',
    'Claymont\\.com',
    'cloakdetect/',
    'clown',
    'cnet\\.com',
    'COAST WebMaster Pro/',
    'CoBITSProbe',
    'coccoc',
    'cocoal\\.icio\\.us/',
    'ColdFusion',
    'collage\\.cgi/',
    'collect',
    'combine/',
    'Commons-HttpClient',
    'ContentSmartz',
    'contenttabreceiver',
    'control',
    'convera',
    'copperegg',
    'coralwebprx/',
    'cosmos',
    'Covac UPPS Cathan',
    'Covario-IDS',
    'crawl',
    'crowsnest/',
    'csci_b659/',
    'curl',
    'cuwhois/',
    'CyberPatrol',
    'DA \\d',
    'DAP x',
    'datacha0s/',
    'datafountains/dmoz',
    'dataprovider',
    'DAUMOA-video',
    'prairielandconsulting',
    'DBrowse \\d',
    'dc-sakura',
    'DDD',
    'de\\.com',
    'deep[-\\s]?link',
    'deepak-usc/isi',
    'del\\.icio\\.us',
    'delegate/',
    'DepSpid',
    'detector',
    'diagem/',
    'diamond/x\\.0',
    'Digg',
    'DigOut4U',
    'DISCo Pump',
    'dlman',
    'dlvr\\.it/',
    'DnloadMage',
    'docomo/',
    'DomainAppender',
    'Download',
    'DreamPassport',
    'drupact',
    'Drupal',
    'DSurf15',
    'DTAAgent',
    'DTS Agent',
    'Dual Proxy',
    'e-sense',
    'EARTHCOM',
    'easydl/',
    'EBrowse \\d',
    'ecairn',
    'echo!/',
    'efp@gmx\\.net',
    'egothor/',
    'ejupiter',
    'ElectricMonk',
    'EmailWolf',
    'Embedly/',
    'envolk',
    'ESurf15',
    'eventax',
    'Evliya Celebi',
    'evrinid',
    'exactseek\\.com',
    'Exalead',
    'Exploratodo/',
    'extract',
    'EyeCatcher',
    'eyes',
    'ezooms',
    'facebookexternalhit',
    'faedit/',
    'FairAd Client',
    'fantom',
    'FastBug',
    'Faveeo/',
    'FavIconizer',
    'FavOrg',
    'FDM \\d',
    'feed',
    'feeltiptop',
    'fetch',
    'fileboost',
    'filtrbox/',
    'FindAnISP',
    'finder',
    'findlink',
    'findthatfile',
    'firefly/',
    'FlashGet',
    'FLATARTS_FAVICO',
    'flexum/',
    'FlipboardRSS/',
    'fluffy',
    'flunky',
    'focusedsampler/',
    'FollowSite',
    'forensiq',
    'francis/',
    'FSurf',
    'FuseBulb\\.Com',
    'g00g1e\\.net',
    'galaxy\\.com',
    'gather',
    'gazz/x\\.x',
    'geek-tools',
    'Generator',
    'genieknows',
    'Genieo',
    'geourl/',
    'getright/',
    'getrightpro/',
    'getter',
    'ghostroutehunter/',
    'gigabaz/',
    'GigablastOpenSource',
    'go-ahead-got-it',
    'Go!Zilla',
    'GoBeez',
    'goblin/',
    'GoForIt\\.com',
    'Goldfire Server',
    'gonzo1',
    'gonzo2',
    'gooblog/',
    'goofer/',
    'Google Web Preview',
    'Google Wireless Transcoder',
    'gopher',
    'gossamer-threads',
    'gozilla\\.com',
    'grapefx/',
    'gromit/',
    'GroupHigh/',
    'grub-client',
    'GTmetrix',
    'gulliver/',
    'H010818',
    'hack',
    'harvest',
    'haste/',
    'Hatena',
    'helix/',
    'heritrix',
    'hippias/',
    'HitList',
    'Holmes',
    'hotmail.com',
    'hound',
    'htdig',
    'html2',
    'http_client',
    'http-header-abfrage/',
    'http::lite/',
    'HTTPGet',
    'HTTPResume',
    'httpunit',
    'httrack',
    'HubSpot Marketing Grader',
    'hyperestraier/',
    'HyperixScoop',
    'ichiro',
    'ics \\d',
    'idealobserver',
    'ideare - SignSite',
    'idwhois',
    'IEFav172Free',
    'iframely/',
    'iltrovatore',
    'imageengine/',
    'images',
    'InAGist',
    'incywincy',
    'index',
    'info@pubblisito',
    'infofly/',
    'infolink/',
    'infomine/',
    'InfoSeek',
    'InfoWizards',
    'inkpeek\\.com',
    'Insitornaut',
    'inspectorwww/',
    'InstallShield',
    'integrity/',
    'integromedb',
    'intelix/',
    'intelliseek\\.com',
    'Internet Ninja',
    'internetlinkagent/',
    'InterseekWeb',
    'IODC',
    'IOI',
    'ip2location\\.com',
    'ips-agent',
    'iqdb/',
    'iria/',
    'irvine/',
    'isitup\\.org',
    'iskanie\\.com',
    'isurf',
    'ivia/',
    'iwagent',
    'j-phone/',
    'Jack',
    'java/',
    'JBH Agent 2\\.0',
    'JemmaTheTourist',
    'JetCar',
    'jigsaw/',
    'Journster',
    'kalooga',
    'Kapere',
    'kasparek@naparek',
    'KDDI-SN22',
    'ke_1\\.0/',
    'Kevin',
    'KimonoLabs',
    'kit-fireball/',
    'KnowItAll',
    'knowledge\\.com/',
    'Kontiki Client',
    'kosmix\\.com',
    'kulturarw3/',
    'kummhttp/',
    'L\\.webis',
    'labrador/',
    'Lachesis',
    'Larbin',
    'leech',
    'leia/',
    'LibertyW',
    'library',
    'libweb/clshttp',
    'Lincoln State Web Browser',
    'Link Commander',
    'Link Valet',
    'linkalarm/',
    'linkdex',
    'LinkExaminer',
    'Linkguard',
    'linkman',
    'LinkPimpin',
    'LinkProver',
    'Links2Go',
    'linksonar/',
    'LinkStash',
    'LinkTiger',
    'Lipperhey',
    'loader',
    'loadimpactrload/',
    'locate',
    'locator',
    'Look\\.com',
    'Lovel',
    'ltx71',
    'lwp-',
    'lwp::',
    'mabontland',
    'mack',
    'magicwml/',
    'mail\\.ru/',
    'mammoth/',
    'MantraAgent',
    'MapoftheInternet',
    'Marketwave Hit List',
    'Martini',
    'Marvin',
    'masagool/',
    'MasterSeek',
    'Mata Hari/',
    'Mediapartners-Google',
    'megaproxy\\.com',
    'MegaSheep',
    'Megite',
    'Mercator',
    'metainspector/',
    'metaspinner/',
    'metatagsdir/',
    'MetaURI',
    'MicroBaz',
    'Microsoft_Internet_Explorer_5',
    'miixpc/',
    'Mindjet MindManager',
    'miniflux\\.net',
    'Missouri College Browse',
    'Mister\\sPix',
    'Mizzu Labs',
    'Mo College',
    'moget/x\\.x',
    'mogimogi',
    'moiNAG',
    'monitor',
    'monkeyagent',
    'monogol\\.de',
    'MonTools',
    'moreover\\.com',
    'Morning Paper',
    'mowser\\.com',
    'Mrcgiguy',
    'MSIE or Firefox mutant',
    'msnptc/',
    'msproxy/',
    'Mulder',
    'multiBlocker browser',
    'multitext/',
    'MuscatFerret',
    'MVAClient',
    'naofavicon4ie',
    'nationaldirectoryaddurl',
    'nearsoftware\\.com',
    'netants/',
    'Netcraft Web Server Survey',
    'NetcraftSurveyAgent',
    'netlookout',
    'netluchs',
    'NetMechanic',
    'netpumper/x\\.xx',
    'NetSprint',
    'netwu\\.com',
    'neutrinoapi',
    'NewsGator',
    'newt',
    'nico/',
    'NORAD National Defence Network',
    'Norton-Safeweb',
    'Notifixious',
    'noyona_0_1',
    'nsauditor',
    'nutch',
    'Nymesis',
    'ocelli',
    'Octopus',
    'Octora Beta',
    'ODP links',
    'oegp',
    'OliverPerry',
    'Onet\\.pl',
    'Oracle Application',
    'Orbiter',
    'OSSProxy',
    'ow\\.ly',
    'ownCloud News',
    'ozelot',
    'Page Speed Insights',
    'Page Valet/',
    'page2rss',
    'Pagebull',
    'Panopta v',
    'panscient',
    'parasite',
    'parse',
    'pavuk',
    'PayPal IPN',
    'PBrowse',
    'pd02_1',
    'Peew',
    'perl',
    'Perman Surfer',
    'PEval',
    'phantom',
    'photon/',
    'php/\\d',
    'Pingdom',
    'Pingoscope',
    'pingspot/',
    'pinterest/',
    'Pita',
    'Pizilla',
    'Ploetz \\+ Zeller',
    'Plukkie',
    'pockey-gethtml',
    'pockey/x\\.x\\.x',
    'Pockey7',
    'Pogodak',
    'Poirot',
    'Pompos',
    'popdexter/',
    'Port Huron Labs',
    'PostFavorites',
    'PostPost',
    'postrank',
    'Powermarks',
    'pricepi\\.com',
    'prlog\\.ru',
    'pro-sitemaps',
    'program',
    'Project XP5',
    'protopage/',
    'proximic',
    'PSurf15a',
    'psycheclone',
    'puf/',
    'PureSight',
    'PuxaRapido',
    'python',
    'Qango\\.com',
    'QuepasaCreep',
    'Qwantify',
    'QXW03018',
    'rabaz',
    'Radian6',
    'RankSonicSiteAuditor',
    'rating',
    'readability/',
    'reader',
    'reaper',
    'ReGet',
    'relevare',
    'responsecodetest',
    'retrieve',
    'rico/',
    'Riddler',
    'Rival IQ',
    'RMA/1\\.0',
    'RoboPal',
    'Robosourcer',
    'robozilla/',
    'rotondo/',
    'rpt-httpclient/',
    'RSurf15a',
    'rtlnieuws',
    'samualt9',
    'saucenao/',
    'SBIder',
    'scan',
    'Scooter',
    'ScoutAbout',
    'scoutant/',
    'ScoutJet',
    'scoutmaster',
    'scrape',
    'Scrapy',
    'Scrubby',
    'search',
    'Seeker\\.lookseek\\.com',
    'seer',
    'semaforo\\.net',
    'semager/',
    'semanticdiscovery',
    'seo-nastroj\\.cz',
    'SEOCentro',
    'SEOstats',
    'Shagseeker',
    'ShopWiki',
    'Siigle Orumcex',
    'SimplyFast\\.info',
    'Simpy',
    'siphon',
    'Site Server',
    'Site24x7',
    'SiteBar',
    'SiteCondor',
    'siteexplorer',
    'SiteRecon',
    'SiteSnagger',
    'sitesucker/',
    'SiteUptime',
    'SiteXpert',
    'sitexy\\.com',
    'skampy/',
    'skimpy/',
    'SkypeUriPreview',
    'slarp/',
    'sleuth',
    'slider\\.com',
    'SlimerJS',
    'slurp',
    'smartwit\\.com',
    'Snappy',
    'sniff',
    'sogou',
    'sohu agent',
    'somewhere',
    'speedy',
    'speng',
    'Sphere Scout',
    'Sphider',
    'spida/',
    'spider',
    'spinne/',
    'spy',
    'squidclam',
    'Sqworm',
    'ssllabs\\.com',
    'SSurf15a',
    'StackRambler',
    'stamina/',
    'StatusCake',
    'suchbaer\\.de',
    'summify',
    'SuperCleaner',
    'SurferF3',
    'SurfMaster',
    'suzuran',
    'sweep',
    'sygol\\.com',
    'synapse',
    'syncit',
    'szukacz/',
    'T-H-U-N-D-E-R-S-T-O-N-E',
    'tags2dir\\.com/',
    'Tagword',
    'Talkro Web-Shot',
    'targetblaster\\.com/',
    'TargetSeek',
    'Teleport Pro',
    'teoma',
    'Teradex Mapper',
    'test certificate',
    'testing',
    'Theophrastus',
    'timelyweb',
    'TinEye',
    'tkensaku',
    'tracker',
    'truwoGPS',
    'TSurf15a',
    'tuezilla',
    'tumblr/',
    'Twingly Recon',
    'Twotrees Reactive Filter',
    'TygoProwler',
    'Ultraseek',
    'unchaos',
    'Under the Rainbow',
    'unknownght',
    'UofTDB_experiment',
    'updated',
    'urlbase/',
    'urlresolver',
    'User-Agent: ',
    'user-agent=mozilla/',
    'utility',
    'utorrent/',
    'Vagabondo',
    'vakes/',
    'validator',
    'vb wininet',
    'verifier',
    'verify',
    'Version: xxxx Type:xx',
    'versus',
    'verzamelgids/',
    'viking',
    'vkshare',
    'voltron',
    'vonna',
    'Vortex',
    'voyager-hc/',
    'VYU2',
    'w3c-webcon/',
    'w3dt\\.net',
    'walker',
    'Wappalyzer',
    'warez',
    'Watchfire WebXM',
    'wavefire/',
    'Waypath Scout',
    'wbsrch\\.com',
    'Web Snooper',
    'web-bekannt',
    'webauto/',
    'webbandit/',
    'webbug/',
    'Webclipping\\.com',
    'webcollage',
    'WebCompass',
    'webcookies',
    'webcorp/',
    'webcraft',
    'Webglimpse',
    'webgobbler/',
    'webinator',
    'weblight/',
    'Weblog Attitude Diffusion',
    'webmastercoffee/',
    'webminer/x\\.x',
    'webmon ',
    'WebPageImager',
    'WebPix',
    'Website Explorer',
    'Websnapr/',
    'Websquash\\.com',
    'webstat/',
    'Webster v0\\.',
    'webstripper/',
    'webtrafficexpress',
    'webtrends/',
    'WebVac',
    'webval/',
    'Webverzeichnis',
    'wf84',
    'WFARC',
    'wget',
    'whatsmyip',
    'whatsup',
    'whatuseek',
    'Whizbang',
    'whoami',
    'whoiam',
    'Wildsoft Surfer',
    'WinGet',
    'WinHTTP',
    'wish-project',
    'wmtips\\.com',
    'WomlpeFactory',
    'WordPress\\.com',
    'WorldLight',
    'worqmada/',
    'worth',
    'wotbox',
    'WoW Lemmings Kathune',
    'WSN Links',
    'wusage/',
    'wwlib/linux',
    'www-mechanize/',
    'wwwc/',
    'wwwoffle/',
    'wwwster/',
    'xirq/',
    'xrl/',
    'Xylix',
    'Y!J-ASR',
    'y!j-srd/',
    'y!oasis/test',
    'yacy',
    'yahoo',
    'YandeG',
    'yandex',
    'yanga',
    'yarienavoir',
    'yeti',
    'Yoleo',
    'Yoono',
    'youtube-dl',
    'Zao',
    'Zearchit',
    'zedzo\\.digest/',
    'zeus',
    'Zippy',
    'ZnajdzFoto',
    'Zotero',
    'ZyBorg'
];
